var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1 23L19.4 20.3C19.0333 20.5167 18.65 20.6875 18.25 20.8125C17.85 20.9375 17.4333 21 17 21C15.75 21 14.6875 20.5625 13.8125 19.6875C12.9375 18.8125 12.5 17.75 12.5 16.5C12.5 15.25 12.9375 14.1875 13.8125 13.3125C14.6875 12.4375 15.75 12 17 12C18.25 12 19.3125 12.4375 20.1875 13.3125C21.0625 14.1875 21.5 15.25 21.5 16.5C21.5 16.9333 21.4375 17.35 21.3125 17.75C21.1875 18.15 21.0167 18.5333 20.8 18.9L23.5 21.6L22.1 23ZM17 19C17.7 19 18.2917 18.7583 18.775 18.275C19.2583 17.7917 19.5 17.2 19.5 16.5C19.5 15.8 19.2583 15.2083 18.775 14.725C18.2917 14.2417 17.7 14 17 14C16.3 14 15.7083 14.2417 15.225 14.725C14.7417 15.2083 14.5 15.8 14.5 16.5C14.5 17.2 14.7417 17.7917 15.225 18.275C15.7083 18.7583 16.3 19 17 19ZM21.5 10H19.5V5H17.5V8H7.5V5H5.5V19H10.5V21H5.5C4.95 21 4.47917 20.8042 4.0875 20.4125C3.69583 20.0208 3.5 19.55 3.5 19V5C3.5 4.45 3.69583 3.97917 4.0875 3.5875C4.47917 3.19583 4.95 3 5.5 3H9.675C9.85833 2.41667 10.2167 1.9375 10.75 1.5625C11.2833 1.1875 11.8667 1 12.5 1C13.1667 1 13.7625 1.1875 14.2875 1.5625C14.8125 1.9375 15.1667 2.41667 15.35 3H19.5C20.05 3 20.5208 3.19583 20.9125 3.5875C21.3042 3.97917 21.5 4.45 21.5 5V10ZM12.5 5C12.7833 5 13.0208 4.90417 13.2125 4.7125C13.4042 4.52083 13.5 4.28333 13.5 4C13.5 3.71667 13.4042 3.47917 13.2125 3.2875C13.0208 3.09583 12.7833 3 12.5 3C12.2167 3 11.9792 3.09583 11.7875 3.2875C11.5958 3.47917 11.5 3.71667 11.5 4C11.5 4.28333 11.5958 4.52083 11.7875 4.7125C11.9792 4.90417 12.2167 5 12.5 5Z",
    fill: "#000E4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlan);
export default __webpack_public_path__ + "static/media/SearchPlan.f1c8dcd68917df49869274ef8ac50237.svg";
export { ForwardRef as ReactComponent };